import { InterceptorClient } from "../../interceptor/interceptorClient";
import { getFnpCashBalanceEndpoint, getFnpCashLabelSystemProperty } from "./constant";

const devBaseUrl = process.env.NEXT_PUBLIC_BASE_URL;
/**
 * API for fetching fnp cash value/balance.
 *
 * @returns {Promise<Object>} - A promise that resolves to the JSON response containing fnpCash balance.
 */
export const getFnpCashBalance = async (params) => {
  try {
    return await InterceptorClient.getFTSInstance(devBaseUrl).get(getFnpCashBalanceEndpoint(params), false);
  } catch (error) {
    console.log(error);
  }
};
/**
 * API for fetching FNP cash label.
 *
 * @returns {Promise<Object>} - A promise that resolves to the JSON response containing FNP cash label data.
 */
export const getFnpCashLabelInfo = async () => {
  try {
    return await InterceptorClient.getFNTSInstance(devBaseUrl).get(getFnpCashLabelSystemProperty(), false);
  } catch (error) {
    console.log(error);
  }
};
